<main class="auth-page auth-flow-page min-vh-100 position-relative overflow-hidden bg-white text-dark">
  <div class="container position-relative min-vh-100 d-flex flex-column px-3 py-3 py-lg-4">
    <section class="flex-grow-1 d-flex align-items-center py-3">
      <div class="row align-items-center justify-content-center g-5 w-100 mx-0">
        <aside class="col-lg-5 d-none d-lg-flex flex-column align-items-center justify-content-center text-center">
          <div class="aic-hero-orb-wrap position-relative mt-0 mb-4">
            <div class="aic-hero-ring aic-hero-ring-outer position-absolute rounded-circle pe-none" aria-hidden="true"></div>
            <div class="aic-hero-ring aic-hero-ring-mid position-absolute rounded-circle pe-none" aria-hidden="true"></div>
            <router-link
              to="/"
              class="aic-hero-orb position-absolute rounded-circle d-flex align-items-center justify-content-center"
              aria-label="AI Campus Data Intelligence home"
            >
              <span class="aic-hero-orb-mark d-block"></span>
            </router-link>
          </div>
          <p class="text-secondary small fw-semibold text-uppercase mt-3 mb-2">Secure reset</p>
          <h1 class="fs-3 fw-bold text-dark mb-3">Set the new key to your property data.</h1>
          <p class="text-secondary small mb-0">
            Choose a strong password before returning to your dashboard.
          </p>
        </aside>

        <section class="auth-panel col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4 card border border-dark bg-white shadow-lg rounded-4 p-4 text-dark mx-auto">
          <p class="text-secondary small fw-semibold text-uppercase mb-2">Account recovery</p>
          <h1 class="fs-3 fw-bold text-dark mb-2">Set a new password</h1>
          <p class="text-secondary small mb-3">Use at least 8 characters for your new password.</p>

          <SnackbarMessage
            :error-message="error_message"
            :success-message="success_message"
            @dismiss-error="error_message = ''"
            @dismiss-success="success_message = ''"
          />

          <div v-if="is_loading" class="text-secondary text-center mb-3">
            <div class="spinner-border spinner-border-sm me-2 text-danger"></div>
            <span>Updating password...</span>
          </div>

          <form v-if="!is_loading" @submit.prevent="submitNewPassword">
            <div class="mb-3">
              <label class="form-label text-secondary small fw-medium mb-1" for="new-password">New password</label>
              <input
                id="new-password"
                v-model="password"
                :type="password_input_type"
                class="form-control form-control-sm bg-white border-secondary text-dark rounded-pill px-3 py-2 shadow-sm"
                placeholder="Enter your new password"
                autocomplete="new-password"
                required
              />
            </div>

            <div class="mb-3">
              <label class="form-label text-secondary small fw-medium mb-1" for="confirm-password">Confirm password</label>
              <div class="position-relative">
                <input
                  id="confirm-password"
                  v-model="confirmPassword"
                  :type="password_input_type"
                  class="form-control form-control-sm bg-white border-secondary text-dark rounded-pill px-3 py-2 pe-5 shadow-sm"
                  placeholder="Confirm your new password"
                  autocomplete="new-password"
                  required
                />
                <button
                  type="button"
                  class="btn btn-link text-secondary position-absolute top-50 end-0 translate-middle-y px-3 py-0 text-decoration-none"
                  @click="toggle_change_password_type"
                  :aria-label="password_input_type === 'password' ? 'Show passwords' : 'Hide passwords'"
                >
                  <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>
            </div>

            <button class="btn btn-danger btn-sm rounded-pill fw-semibold w-100 px-3 py-2 shadow-sm mb-3">
              Save new password
            </button>

            <p class="text-secondary text-center small mb-0">
              Remember your password?
              <router-link to="/login" class="text-danger fw-bold text-decoration-none">
                Sign in
              </router-link>
            </p>
          </form>
        </section>
      </div>
    </section>
  </div>
</main>
